import {
    useCallback,
    useContext,
    createContext
} from 'react';
  
import { parseISO } from 'date-fns';

import { acoesTerritoriaisService } from '../api/acoesTerritoriaisService';
import { usuariosATService } from '../api/usuariosATService';

import { decrypt } from '../helpers/cryptography';
  
const AcoesTerritoriaisContext = createContext({});

export const AcoesTerritoriaisProvider = ({ children }) => {

  const getAllAcoesTerritoriais = useCallback(async (pageNumber, limit, filterBy, orderBy) => {
    try {
        const response = await acoesTerritoriaisService.allAcoesTerritoriais(pageNumber, limit, filterBy, orderBy);

        return response;
    } catch (error) {
        console.log(error);
    }
  }, []);

  const getAcaoTerritorialById = useCallback(async (id) => {
    try {
        const response = await acoesTerritoriaisService.getAcaoTerritorial(id);

        const cleanResponse = {
            ...response,
            dataAtividade: parseISO(response.dataAtividade),
        }

        return cleanResponse;
    } catch (error) {
        console.log(error);
    }
  }, []);

  const getUsuariosAcaoTerritorial = useCallback(async (id) => {
    try {
        const response = await acoesTerritoriaisService.usuariosAcaoTerritorial(id);
        const cleanResponse = response?.map(item => ({
          ...item,
          nomeCompleto: item.nomeCompleto ? decrypt(item.nomeCompleto) : '',
          nomeSocial: item.nomeSocial ? decrypt(item.nomeSocial) : '',
          documentos: item.documentos ? decrypt(item.documentos) : '',
        }))
        return cleanResponse;
    } catch (error) {
        console.log(error);
    }
  }, []);

  const updateAcaoTerritorial = useCallback(async (id, data) => {
    try {
      const response = await acoesTerritoriaisService.update(id, data);
      
      return response;

    } catch (error) {
        console.log(error);
    }
  }, []);

  const deleteAcaoTerritorial = useCallback(async (id) => {
    try {
        const response = await acoesTerritoriaisService.delete(id);

        if (!response.ok) {
            throw new Error('Ocorreu um erro inesperado');
        }
    } catch (error) {
        console.log(error);
    }
  }, []);

  const createAcaoTerritorial = useCallback(async (data) => {
    try {
      const response = await acoesTerritoriaisService.create(data);

      if (!response.ok) {
          throw new Error('Ocorreu um erro inesperado');
      }
    } catch (error) {
        console.log(error);
    }
  }, []);

  const getUsuarioATById = useCallback(async (id) => {
    try {
        const response = await usuariosATService.get(id);

        const cleanResponse = {
            ...response,
            nomeCompleto: response?.nomeCompleto ? decrypt(response.nomeCompleto) : '',
            nomeSocial: response?.nomeSocial ? decrypt(response.nomeSocial) : '',
            documentos: response?.documentos ? decrypt(response.documentos) : '',
        }

        return cleanResponse;
    } catch (error) {
        console.log(error);
    }
  }, []);

  const updateUsuarioAT = useCallback(async (id, data) => {
    try {
      const response = await usuariosATService.update(id, data);
      
      return response;

    } catch (error) {
        console.log(error);
    }
  }, []);

  const deleteUsuarioAT = useCallback(async (id) => {
    try {
        const response = await usuariosATService.delete(id);

        if (!response.ok) {
            throw new Error('Ocorreu um erro inesperado');
        }
    } catch (error) {
        console.log(error);
    }
  }, []);

  const createUsuarioAT = useCallback(async (data) => {
    try {
        const response = await usuariosATService.create(data);

        if (!response.ok) {
          throw new Error('Ocorreu um erro inesperado');
        }
    } catch (error) {
        console.log(error);
    }
  }, []);

  const createAtividade = useCallback(async (id, data) => {
    try {
      const response = await acoesTerritoriaisService.createAtividade(id, data);
      
      return response;

    } catch (error) {
        console.log(error);
    }
  }, []);

  const updateAtividade = useCallback(async (idAT, id,data) => {
    try {
      const response = await acoesTerritoriaisService.updateAtividade(idAT, id, data);
      
      return response;

    } catch (error) {
        console.log(error);
    }
  }, []);

  const addUsuarioToAcaoTerritorial = useCallback(async (idAT, id) => {
    try {
      const response = await acoesTerritoriaisService.addUsuarioAT(idAT, id);
      
      return response;

    } catch (error) {
        console.log(error);
    }
  }, []);

  const buscaAllUsuarios = useCallback(async (campo, valor, cripto) => {
    try {
      const response = await acoesTerritoriaisService.buscaUsuarios(campo, valor, cripto);
      const cleanResponse = response.map(item => ({
        ...item,
        nomeCompleto: item.nomeCompleto ? decrypt(item.nomeCompleto) : '',
        nomeSocial: item.nomeSocial ? decrypt(item.nomeSocial) : '',
        documentos: item.documentos ? decrypt(item.documentos) : '',
      }))
      return cleanResponse;

    } catch (error) {
        console.log(error);
    }
  }, []);

  const getAcoesUsuarioCAPS = useCallback(async (uuid) => {
    try {
      const response = await acoesTerritoriaisService.usuarioAcoes(uuid);
      return response;

    } catch (error) {
        console.log(error);
    }
  }, []);

  const patchATStatus = useCallback(async (id, status) => {
    try {
      const response = await acoesTerritoriaisService.patchStatus(id, status);
      return response;

    } catch (error) {
        console.log(error);
    }
  }, []);

  const getRelatorio = useCallback(async (territorio = '') => {
    try {
        const response = await acoesTerritoriaisService.relatorio(territorio);

        return response;
    } catch (error) {
        console.log(error);
    }
  }, []);

  const acoesTerritoriaisInitialValues = {
      territorio: '',
      dataAtividade: '',
      servicoResponsavel: [],
      equipeResponsavel: [],
      atividadeCompartilhada: '',
      qualAtividade: '',
      status: 'Rascunho',
      usuarios: [],
      atividades: [],   
  };

  const usuarioATInitialValues = {
    nomeCompleto: '',
    nomeSocial: '',
    apelido: '',
    genero: '',
    racaCor: '',
    dataNascimento: '',
    idade: '',
    deficiencia: '',
    unidadeReferencia: '',
    publicoAlvo: [],
    caps: '',
    capsOrigem: '',
    ausenciaDoc: [],
    infosComplementares: '',
    documentos: '',
  };

  return (
    <AcoesTerritoriaisContext.Provider
      value={{
        getAllAcoesTerritoriais,
        getAcaoTerritorialById,
        updateAcaoTerritorial,
        deleteAcaoTerritorial,
        createAcaoTerritorial,
        getUsuariosAcaoTerritorial,
        addUsuarioToAcaoTerritorial,
        buscaAllUsuarios,
        getAcoesUsuarioCAPS,
        createUsuarioAT,
        updateUsuarioAT,
        deleteUsuarioAT,
        getUsuarioATById,
        createAtividade,
        updateAtividade,
        patchATStatus,
        getRelatorio,
        acoesTerritoriaisInitialValues,
        usuarioATInitialValues,
      }}
    >
      {children}
    </AcoesTerritoriaisContext.Provider>
  );
}

export const useAcoesTerritoriais = () => useContext(AcoesTerritoriaisContext);